import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RemoveResidentModel } from '@shared/models/data/remove-resident';
import { ResidentModel } from '@shared/models/data/resident-model';
import { EnrollmentService } from '@shared/services/enrollment.service';

@Component({
  selector: 'aaos-app-resident-remove-dialog',
  templateUrl: './resident-remove-dialog.component.html',
  styleUrls: ['./resident-remove-dialog.component.scss']
})
export class ResidentRemoveDialogComponent {

  removeResidentError = false;
  loading = false;

  constructor(public dialogRef: MatDialogRef<ResidentRemoveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResidentModel,
    private enrollmentService: EnrollmentService
    ) { }


  public removeResident() {
    this.loading = true;

    const removeResident: RemoveResidentModel = {
      InstitutionId: this.data.institutionId,
      ResidentId: this.data.id
    };
    this.enrollmentService.deleteResident(removeResident).subscribe(response => {
      this.loading = false;

      if (response.errors.length === 0) {
        this.dialogRef.close();
      } else {
        this.removeResidentError = true;
      }
    });

  }

}
